import React from 'react';
import { Link } from 'react-router-dom';
import { Donor } from '../../models/Donor';

type StdSemenInfoProps = {
  donor: Donor;
}

const StdSemenInfo = (props: StdSemenInfoProps) => {
  const { donor } = props;

  return (
    <>
      <h2 className="main_title"><span>検査結果</span></h2>
      <div className="prof_contents">
        <section>
          <h3 className="sub_title">性病検査結果</h3>
          {
            donor.std.certified
              ? <h4>診断書登録済</h4>
              : <h4 className="gray">診断書未登録</h4>
          }
          <div className="wrap">
            <dl className="graf_list">
              <dt>検査結果</dt>
              <dd>
                {
                  donor.std.certified && donor.std.total === 'MINUS'
                    ? <span className="checkup-result">◎（陽性なし）</span>
                    : <span className="checkup-result gray">-</span>
                }
              </dd>
            </dl>
            <dl className="graf_list">
              <dt>採取日</dt>
              <dd>
                {
                  donor.std.certified
                    ? <>{ donor.std.collectedOnText }</>
                    : <>-</>
                }
              </dd>
            </dl>
          </div>
        </section>
        <section>
          <h3 className="sub_title">精液検査結果</h3>
          {
            donor.semen.certified
              ? <h4>診断書登録済</h4>
              : <h4 className="gray">診断書未登録</h4>
          }
          <div className="wrap">
            <dl className="graf_list">
              <dt>精子品質</dt>
              <dd>
                {
                  donor.semen.certified
                    ? <span className="checkup-result">{ donor.semen.total }</span>
                    : <span className="checkup-result gray">-</span>
                }
                ※評価目安は<Link to="/faq#help-sperm-calc">こちら</Link>
              </dd>
              <dt>精液量</dt>
              <dd>
                {
                  donor.semen.certified
                    ? <>{ donor.semen.volume } ml</>
                    : <>-</>
                }
              </dd>
              <dt>総精子数</dt>
              <dd>
                {
                  donor.semen.certified
                    ? <>{ donor.semen.totalCount } 万</>
                    : <>-</>
                }
              </dd>
              <dt>正常形態率</dt>
              <dd>
                {
                  donor.semen.certified && donor.semen.morphology
                    ? <>{ donor.semen.morphology } %</>
                    : <>-</>
                }
              </dd>
            </dl>
            <dl className="graf_list">
              <dt>採取日</dt>
              <dd>
                {
                  donor.semen.certified
                    ? <>{ donor.semen.collectedOnText }</>
                    : <>-</>
                }
              </dd>
              <dt>精子濃度</dt>
              <dd>
                {
                  donor.semen.certified
                    ? <>{ donor.semen.concentration } 万/ml</>
                    : <>-</>
                }
              </dd>
              <dt>運動率</dt>
              <dd>
                {
                  donor.semen.certified && donor.semen.motility
                    ? <>{ donor.semen.motility } %</>
                    : <>-</>
                }
              </dd>
            </dl>
          </div>
        </section>
      </div>
    </>
  );
}

export default StdSemenInfo;
